/* SLIDE 35 */


import React, { useState, useEffect } from "react";
import ButtonBot from "shared/components/ButtonBot";
import { useNavigate } from "react-router-dom";
import Popup from "shared/components/Popup";
import PopupFilter from "shared/components/PopupFilter";
import SearchBar from "shared/components/SearchBar";
import AppCheckBox from "../../../shared/components/AppCheckBox";
import arrowDownIcon from "assets/icons/arrowDownIcon.svg";
import { getUserList } from "features/user/usecases/UserUsecases";
import { useSelector } from "react-redux";
import closeIcon from 'assets/icons/close.svg';

const UserManager = () => {
    const navigation = useNavigate();
    const [showPopupFilter, setShowPopupFilter] = useState(false);
    const [showPopupDelete, setShowPopupDelete] = useState(false);
    const [userData, setUserData] = useState([]);
    const [keyword, setKeyword] = useState("");
    const { user } = useSelector((state) => state.auth);

    const onNavi = (path) => {
        navigation(path);
    };

    const fetchUserData = async (searchTerm = "") => {
        const result = await getUserList({
            id: "01",
            keyword: searchTerm
        });
        
        if (result) {
            setUserData(result.data);
        }else{
            setUserData([
                {
                    id: "1",
                    type: "근무자",
                    user_id: "01-002",
                    name: "박길동",
                    regtime: "2024-10-10 13:57"
                },
                {
                    id: "2",
                    type: "근무자",
                    user_id: "01-002",
                    name: "박길동",
                    regtime: "2024-10-10 13:57"
                },
                {
                    id: "3",
                    type: "근무자",
                    user_id: "01-002",
                    name: "박길동",
                    regtime: "2024-10-10 13:57"
                },
                {
                    id: "4",
                    type: "근무자",
                    user_id: "01-002",
                    name: "박길동",
                    regtime: "2024-10-10 13:57"
                },

                {
                    id: "5",
                    type: "근무자",
                    user_id: "01-002",
                    name: "박길동",
                    regtime: "2024-10-10 13:57"
                },
                {
                    id: "6",
                    type: "근무자",
                    user_id: "01-002",
                    name: "박길동",
                    regtime: "2024-10-10 13:57"
                }
            ]);
        }
    };

    const handleSearchClick = () => {
        fetchUserData(keyword);
    };

    useEffect(() => {
        fetchUserData(); // First call when on the page
    }, []);

    const [selectedIds, setSelectedIds] = useState([]);
    const [checkAll, setCheckAll] = useState(false);

    //Toggle individual checkbox
    const toggleCheckbox = (id) => {
        const updated = selectedIds.includes(id)
            ? selectedIds.filter((i) => i !== id)
            : [...selectedIds, id];

        setSelectedIds(updated);
        setCheckAll(updated.length === parkingData.length); // auto update checkAll
    };

    //Toggle all
    const toggleCheckAll = () => {
        if (checkAll) {
            setSelectedIds([]);
        } else {
            setSelectedIds(parkingData.map((item) => item.id));
        }
        setCheckAll(!checkAll);
    };

    // setUserData([
    //     {
    //         id: "1",
    //         type: "근무자",
    //         user_id: "01-002",
    //         name: "박길동",
    //         regtime: "2024-10-10 13:57"
    //     },
    //     {
    //         id: "2",
    //         type: "근무자",
    //         user_id: "01-002",
    //         name: "박길동",
    //         regtime: "2024-10-10 13:57"
    //     },
    //     {
    //         id: "3",
    //         type: "근무자",
    //         user_id: "01-002",
    //         name: "박길동",
    //         regtime: "2024-10-10 13:57"
    //     },
    //     {
    //         id: "4",
    //         type: "근무자",
    //         user_id: "01-002",
    //         name: "박길동",
    //         regtime: "2024-10-10 13:57"
    //     },

    //     {
    //         id: "5",
    //         type: "근무자",
    //         user_id: "01-002",
    //         name: "박길동",
    //         regtime: "2024-10-10 13:57"
    //     },
    //     {
    //         id: "6",
    //         type: "근무자",
    //         user_id: "01-002",
    //         name: "박길동",
    //         regtime: "2024-10-10 13:57"
    //     }
    // ]);

    return (
        <div className="parking-status-container ">
            <SearchBar placeholder="주차장명 또는 관리번호로 검색 ..." className="pb-15"  onChange={(e) => setKeyword(e.target.value)} handleSearchClick={handleSearchClick}></SearchBar>

            <div className="select-filter mx-20 my-0">
                <select
                    name="filter"
                >
                    <option value="구분">구분</option>
                </select>
            </div>


            <div className="table-container mt-20">
                <table className="parking-table mn-parking-table">
                    <thead>
                        <tr>
                            <th className="pl-5">
                                <AppCheckBox checked={checkAll} onChange={toggleCheckAll}></AppCheckBox>
                            </th>
                            <th onClick={() => setShowPopupFilter(true)}>사용자구분</th>
                            <th onClick={() => setShowPopupFilter(true)}>사용자ID</th>
                            <th onClick={() => setShowPopupFilter(true)}>사용자명</th>
                            <th onClick={() => setShowPopupFilter(true)}>등록일자</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userData.map((item) => (
                            <tr key={item.id} onClick={() => onNavi("/user_manager_edit")}>
                                <td className="pl-5">
                                    <AppCheckBox checked={selectedIds.includes(item.id)} onChange={() => toggleCheckbox(item.id)}></AppCheckBox>

                                </td>
                                <td>{item.type}</td>
                                <td>{item.user_id}</td>
                                <td>{item.name}</td>
                                <td>
                                    <div className="flex flex-col">
                                        <span>{item.regtime.split(" ")[0]}</span>
                                        <span>{item.regtime.split(" ")[1]}</span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <ButtonBot textYes={"등록하기"} handleYes={() => onNavi("/user_manager_edit")}
                textNo={"삭제하기"} handleNo={() => setShowPopupDelete(true)} />
            {showPopupFilter && (
                <PopupFilter title="사용자구분 선택" handleYes={() => setShowPopupFilter(false)} textYes="저장하기" textNo="취소" setVisible={setShowPopupFilter} options={['전체', '관리자', '근무자']}>

                </PopupFilter>
            )}
            {showPopupDelete && (
                <Popup title="사용자 삭제" handleYes={() => setShowPopupDelete(false)} textYes="삭제" textNo="닫기" setVisible={setShowPopupDelete}>
                    <div className="nl-row f-column col-12">
                        <p>선택한 사용자가 삭제됩니다.</p> 정말로 삭제하시겠습니까?
                    </div>
                   
                </Popup>
            )}
        </div>
    );
};

export default UserManager;
